

export class UserAddBranchDetailIdInput implements IUserAddBranchDetailIdInput {
    /** The auto-generated id of the branch */
    branchDetailId!: number;

    constructor(data?: IUserAddBranchDetailIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branchDetailId = _data["branchDetailId"];
        }
    }

    static fromJS(data: any): UserAddBranchDetailIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserAddBranchDetailIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branchDetailId"] = this.branchDetailId;
        return data; 
    }
}

export interface IUserAddBranchDetailIdInput {
    /** The auto-generated id of the branch */
    branchDetailId: number;
}

